import debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { sureClone } from "@/lib/DataUtils";

import ModuleBase from "../common/ModuleBase";

const d = debug(`${import.meta.env.VITE_PREFIX}:ResourcesStore`);

const DEFAULT_EDITOR = {
  id: null,
  name: null,
  state: "DISABLED"
};

export default ModuleBase({
  state: {
    resources: [],
    editor: sureClone(DEFAULT_EDITOR)
  },
  getters: {
    resources({ resources }) {
      return resources;
    }
  },
  mutations: {
    updateResourceState(state, { resourceId, newState, stateChangedAt }) {
      for (const resourceCategory of state.resources) {
        for (const group of resourceCategory.resourceGroups) {
          const resource = group.resources.find(r => r.id === resourceId);
          if (resource) {
            resource.state = newState;
            resource.stateChangedAt = stateChangedAt;
            return;
          }
        }
      }
    }
  },
  actions: {
    async load({ commit }) {
      debug("load");
      let resources = await ApiClient.get(`/resourcetable `);
      debug("load", resources);
      commit("set", ["resources", resources]);
    },
    async changeState(_, { resourceId, state }) {
      debug("changeState", resourceId);
      let result = await ApiClient.post(`/resources/${resourceId}/state`, {
        state
      });
      debug("changeState - result", result);
    }
  }
});
